<template>
  <div class="product-information" :class="{ 'sold-out': isSoldOut(item) }" @click="buying(item)">
    <div class="title">
      <span>{{ item.name }}</span>
      <van-tag class="points" v-if="item.scoreRate > 0">返积分</van-tag>
      <img v-if="
          (item.productLevel === 1 || item.productLevel === 2) &&
          item.serverTime <= item.endTime
        " class="hot-tag" src="../assets/img/hot.png" alt />
    </div>

    <div class="tag">
      <van-tag class="tag1" v-if="item.label1" :class="{ hide: !item.label1 || item.label1.length < 1 }" plain color="#ff9900">{{ item.label1 }}</van-tag>

      <van-tag class="tag2" v-if="item.label2" :class="{ hide: !item.label2 || item.label2.length < 1 }" plain color="#ff9900">{{ item.label2 }}</van-tag>
      <van-tag v-if="item.attachLabel" plain color="#ff9900">{{
        item.attachLabel
      }}</van-tag>
    </div>

    <div class="data">
      <!-- gain -->
      <div class="gain">
        <template v-if="item.ifStair">
          <b>{{ rateInterval(item).minRate }}</b>
          <span>%</span>
          <span class="fuhao">~</span>
          <b>{{ rateInterval(item).maxRate }}</b>
          <span>%</span>
          <!-- <span class="fuhao">+</span>
            <b>3</b>
            <span>%</span> -->
        </template>
        <template v-else>
          <b>{{ expectedRate(item) }}</b>
          <span>%</span>
          <template v-if="item.greenhandRate && item.greenhandRate > 0">
            <span class="fuhao">+</span>
            <b>{{ item.greenhandRate }}</b>
            <span>%</span>
          </template>
        </template>
        <!-- text -->
        <div class="txt">预期年化收益率</div>
      </div>

      <!-- term -->
      <div class="term">
        <div class="term-box">
          <!-- day -->
          <div class="day">
            <span class="s1">{{ item.investDuration }}</span>
            <span class="s2">天</span>
          </div>
          <!-- text -->
          <!-- <div class="txt">{{ item.miniAmount / 1000000 }}万元起投</div> -->
        </div>
      </div>
    </div>
    <!-- progress -->
    <div class="progress">
      <div class="progress-box">
        <!-- progress-style -->
        <div class="progress-style">
          <div v-if="isSoldOut(item)" class="progress-pivot" style="width: 100%"></div>
          <div v-else class="progress-pivot" :style="{ width: item.sold + '%' }"></div>
        </div>
        <!-- result -->
        <div class="result">{{ progressText(item) }}</div>
      </div>
    </div>

    <div class="aside" v-if="item.saleLabel === '1' && item.isFull <= item.endTime">
      新手专享
    </div>
    <div :class="_isOnlyShowShuang11Icon() ? 'label-img' : 'aside'" v-if="
        (item.saleLabel === '2' || item.productLevel === 1) &&
        item.serverTime <= item.endTime
      ">
      <img v-if="_isOnlyShowShuang11Icon()" style="width: 35px" class="hot-tag" src="../assets/img/common/shuang11-rate.jpg" alt />
      <span v-else>{{ item.hotRate ? "热销加息" : "人气产品" }}</span>
    </div>
    <div class="aside" v-if="item.saleLabel === '4' && item.serverTime <= item.endTime">
      秒杀
    </div>
    <div class="aside" v-if="item.productLevel === 2 && item.serverTime <= item.endTime">
      加息
    </div>

    <div v-if="item.serverTime >= item.endTime" class="signet-sold-out">
      已结束
    </div>
    <div v-if="item.isFull" class="signet-sold-out">已售罄</div>
  </div>
</template>

<script>
import { Tag } from "vant"
export default {
  name: "ProductItem",
  props: {
    item: {
      required: true
    }
  },
  methods: {
    isSoldOut(n) {
      return n.isFull || n.serverTime >= n.endTime
    },
    rateInterval: function (n) {
      // console.info(n)
      if (n.ifStair) {
        let stairRate = n.stairRate
        let minRate = 10000,
          maxRate = 0
        let keys = ["One", "Two", "Three", "Four", "Five", "Six"]
        keys.forEach((k) => {
          if (stairRate["rate" + k]) {
            if (minRate > n.stairRate["rate" + k]) {
              minRate = n.stairRate["rate" + k]
            }
            if (maxRate < n.stairRate["rate" + k]) {
              maxRate = n.stairRate["rate" + k]
            }
          }
        })
        if (n.hasNewYearActivity && n.activityDiscount) {
          //有新年红包活动
          return {
            minRate: parseFloat(minRate + n.activityDiscount.rate).toFixed(2),
            maxRate: parseFloat(maxRate + n.activityDiscount.rate).toFixed(2)
          }
        } else {
          return { minRate: minRate, maxRate: maxRate }
        }
      }
    },
    expectedRate: function (n) {
      if (n.hasNewYearActivity && n.activityDiscount) {
        return parseFloat(n.expectedRate + n.activityDiscount.rate).toFixed(2)
      } else {
        return n.expectedRate
      }
    },
    progressText: function (item) {
      // console.info(item);
      if (this.isSoldOut(item)) {
        return "100%"
      } else {
        if (item.sold > 90) {
          return "即将售罄"
        } else if (item.sold < 10) {
          return "新开抢中"
        } else {
          return item.sold + "%"
        }
      }
    },
    buying(product) {
      this.$router.push({ path: "/detail", query: { productId: product.id } })
    }
  },
  components: {
    [Tag.name]: Tag
  }
}
</script>

<style lang="less" scoped>
.product-information {
  padding: 2px 12px;
  margin: 0 13px;
  margin-bottom: 5px;
  background-color: #fff;
  border-radius: 5px;
  position: relative;
  &.sold-out {
    filter: grayscale(0%) opacity(0.6);
  }

  // name
  .title {
    font-size: 16px;
    height: 1.5em;
    overflow: hidden;
    color: #333333;
    word-break: break-all;
    .points {
      margin-left: 5px;
      color: #ffffff;
      border-radius: 3px;
      background-color: #fc6524;
    }
    .hot-tag {
      width: 20px;
      margin-left: 15px;
    }
  }
  // tag
  .tag {
    //  margin-left: -6px;
    .van-hairline--surround::after {
      border: none;
    }
    .van-tag {
      font-size: 12px;
      margin-right: 3px;
    }
    .hide {
      display: none;
    }

    div {
      display: inline-block;
      height: 8px;
      width: 0.8px;
      background-color: #ff9900;
    }
  }
  // data
  .data {
    margin-top: -10px;
    display: flex;
    align-items: center;
    // text
    .txt {
      color: #999;
      margin-top: -10px;
      font-size: 14px;
    }
    // gain
    .gain {
      flex: 1;
      b {
        font-size: 36px;
        color: #fc6524;
        font-weight: normal;
      }
      span {
        font-size: 15px;
        color: #fc6524;
        margin-left: 1px;
      }
      .fuhao {
        font-size: 18px;
        color: #fc6524;
        margin: auto 5px;
      }
    }
    // term
    .term {
      flex: 1;
      text-align: center;
      .term-box {
        height: 65px;
        padding-right: 25px;
        // day
        .day {
          height: 50px;
          line-height: 50px;
          height: 100%;
          color: #666;
          .s1 {
            font-size: 22px;
          }
          .s2 {
            font-size: 18px;
            margin-left: 2px;
          }
        }
      }
    }
  }
  // progress
  .progress {
    margin-top: -6px;
    .progress-box {
      display: flex;
      align-items: center;
      // title
      .title {
        font-size: 11px;
        color: #666;
      }
      // progress-style
      .progress-style {
        width: 250px;
        height: 4px;
        line-height: 16px;
        position: relative;
        background-color: #e9e9e9;
        border-radius: 4px;
        overflow: hidden;
        .progress-pivot {
          box-sizing: border-box;
          height: 100%;
          background-color: #fc6524;
          border-radius: 4px;
        }
      }
      // result
      .result {
        font-size: 14px;
        margin-left: 10px;
        color: #666;
      }
    }
  }

  .aside,
  .signet-sold-out {
    position: absolute;
    top: 4px;
    right: 0px;
    padding: 0 12px;
    line-height: 24px;
    text-align: center;
    font-size: 13px;
    box-sizing: border-box;
    border-radius: 25px 0 0 25px;
    color: #fff;
  }
  .signet-sold-out {
    background-color: #d6d6d7;
  }
  .aside {
    background-color: rgb(252, 101, 36);
  }
  .label-img {
    position: absolute;
    top: 0px;
    right: 0px;
    padding: 0;
  }
}
</style>
